var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgFilter(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.612 11.596v7.839m-12.224-4.9c1.318 0 2.387-1.096 2.387-2.449 0-1.353-1.069-2.45-2.387-2.45C5.069 9.637 4 10.734 4 12.087c0 1.353 1.069 2.45 2.388 2.45zm6.112 3.92c1.319 0 2.388-1.097 2.388-2.45 0-1.352-1.07-2.45-2.388-2.45-1.319 0-2.388 1.098-2.388 2.45 0 1.353 1.07 2.45 2.388 2.45zm6.112-6.859c1.319 0 2.388-1.096 2.388-2.45 0-1.352-1.069-2.448-2.388-2.448-1.318 0-2.387 1.096-2.387 2.449 0 1.353 1.069 2.45 2.387 2.45zm-6.112 6.99v.849m-6.112-4.9v4.9M18.612 5.718v.544M12.5 5.718v7.838M6.388 5.718v3.74",
    stroke: "#0B0B0B",
    strokeWidth: 2,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round"
  })));
}

export default SvgFilter;